import React from 'react';
import { GenericReportingDropdowns } from '../containers/GenericReportingDropdowns';
import { Tabs } from 'antd';
import LifetimeRevenue from '../containers/CustomerRetention/LifetimeRevenue';
import CohortedRetention from '../containers/CustomerRetention/CohortedRetention';
import CategoricalLtr from '../containers/CustomerRetention/CategoricalLtr';
import CategoricalRetention from '../containers/CustomerRetention/CategoricalRetention';
import LtvVsCac from '../containers/CustomerRetention/LtvVsCac';
import CustomerSurvival from '../containers/CustomerRetention/CustomerSurvival';
import CategoricalCustomerSurvival from '../containers/CustomerRetention/CategoricalCustomerSurvival';
import CategoricalRetentionWithFilters from '../containers/CustomerRetention/CategoricalRetentionWithFilters';

const RetentionPage = () => {

    const tabs = [
        {
            label: 'Lifetime Revenue',
            key: 'Lifetime Revenue',
            children: [<LifetimeRevenue></LifetimeRevenue>]
        },
        {
            label: 'LTV Vs CAC',
            key: 'LTV Vs CAC',
            children: [<LtvVsCac></LtvVsCac>]
        },
        {
            label: 'Cohorted Retention',
            key: 'Cohorted Retention',
            children: [<CohortedRetention></CohortedRetention>]
        },
        {
            label: 'Customer Survival',
            key: 'Customer Survival',
            children: [<CustomerSurvival></CustomerSurvival>]
        },
        {
            label: 'Categorical LTR',
            key: 'Categorical LTR',
            children: [<CategoricalLtr></CategoricalLtr>]
        },
        {
            label: 'Categorical Retention',
            key: 'Categorical Retention',
            children: [<CategoricalRetention></CategoricalRetention>]
        },
        {
            label: 'Categorical Retention with Filters',
            key: 'Categorical Retention with Filters',
            children: [<CategoricalRetentionWithFilters></CategoricalRetentionWithFilters>]
        },
        {
            label: 'Categorical Customer Survival',
            key: 'Categorical Customer Survival',
            children: [<CategoricalCustomerSurvival></CategoricalCustomerSurvival>]
        }
    ]

    return (
      <div
        style={{
          width: "100%",
        }}
      >
        <div
          style={{
            width: "100%",
          }}
        >
          <GenericReportingDropdowns
            includeDateRange={false}
          ></GenericReportingDropdowns>
          <Tabs items={tabs}></Tabs>
        </div>
      </div>
    );
};

export default RetentionPage;